"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CondicionesDeReserva = void 0;

var _react = _interopRequireDefault(require("react"));

var _material = require("@mui/material");

var _HelpOutlined = _interopRequireDefault(require("@mui/icons-material/HelpOutlined"));

var _style = _interopRequireDefault(require("./style"));

var _react2 = require("@emotion/react");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

class CondicionesDeReserva extends _react.default.Component {
  constructor(props) {
    super(props);
    this.handleChangeCancelacion = this.handleChangeCancelacion.bind(this);
    this.handleChangeCheckHuecos = this.handleChangeCheckHuecos.bind(this);
    this.handleChangeSelect = this.handleChangeSelect.bind(this);
    this.handleTooltipOpen = this.handleTooltipOpen.bind(this);
    this.handleTooltipClose = this.handleTooltipClose.bind(this);
    this.state = {
      checkHuecos: this.props.estadiaMinimaHuecos ? true : false,
      openTooltip: false
    };
  }

  handleChangeCancelacion(event) {
    this.props.onChange(event.target.value, event.target.name);
  }

  handleChangeCheckHuecos(event) {
    this.setState({
      checkHuecos: event.target.checked
    }, () => {
      // cuando el check de permitir estadias entre reservas es false seteo el valor del campo estadia_minima_huecos como null
      if (!this.state.checkHuecos) {
        this.props.onChange(null, 'estadia_minima_huecos');
      }
    });
  }

  handleChangeSelect(event) {
    this.props.onChange(event.target.value, event.target.name);
  }

  handleTooltipOpen() {
    this.setState({
      openTooltip: true
    });
  }

  handleTooltipClose() {
    this.setState({
      openTooltip: false
    });
  }

  render() {
    const {
      seña,
      valorDiasCancelacionGratis,
      valorMesesCancelacionFlexible,
      estadiaMinima,
      estadiaMinimaHuecos,
      antelacionMinima,
      horaIngreso,
      horaEgreso,
      cancelacion,
      isMobile
    } = this.props;
    const optionsEstadiaMinima = [];

    for (let index = 1; index < 16; index++) {
      optionsEstadiaMinima.push((0, _react2.jsx)(_material.MenuItem, {
        key: index,
        value: index
      }, index, " ", index == 1 ? 'noche' : 'noches'));
    }

    const optionsEstadiaMinimaEntreReservas = [];

    for (let index = 1; index < estadiaMinima; index++) {
      optionsEstadiaMinimaEntreReservas.push((0, _react2.jsx)(_material.MenuItem, {
        key: index,
        value: index
      }, index, " ", index == 1 ? 'noche' : 'noches'));
    }

    const optionsCancelacionGratis = [];

    for (let index = 1; index < 31; index++) {
      optionsCancelacionGratis.push((0, _react2.jsx)(_material.MenuItem, {
        key: index,
        value: index
      }, index));
    }

    const selectCancelacionGratis = (0, _react2.jsx)(_material.FormControl, {
      variant: "standard",
      disabled: cancelacion != "gratis"
    }, (0, _react2.jsx)(_material.Select, {
      labelId: "demo-simple-select-label-gratis",
      id: "demo-simple-select-gratis",
      value: valorDiasCancelacionGratis,
      name: "valor_dias_cancelacion_gratis",
      label: "dias",
      onChange: e => this.handleChangeSelect(e)
    }, optionsCancelacionGratis));
    const optionsCancelacionFlexible = [];

    for (let index = 1; index <= valorMesesCancelacionFlexible; index++) {
      optionsCancelacionFlexible.push((0, _react2.jsx)(_material.MenuItem, {
        key: index,
        value: index
      }, index));
    }

    const selectCancelacionFlexible = (0, _react2.jsx)(_material.FormControl, {
      variant: "standard",
      disabled: cancelacion != "flexible"
    }, (0, _react2.jsx)(_material.Select, {
      labelId: "demo-simple-select-label-flexible",
      id: "demo-simple-select-flexible",
      value: valorMesesCancelacionFlexible,
      name: "valor_meses_cancelacion_flexible",
      label: "meses",
      onChange: e => this.handleChangeSelect(e)
    }, optionsCancelacionFlexible));
    const cancelacionGratis = (0, _react2.jsx)(_material.Box, null, (0, _react2.jsx)(_material.Typography, {
      css: _style.default.bold,
      component: "label"
    }, "Cancelaci\xF3n Gratis - Se\xF1a Reembolsable:"), " Ante la cancelaci\xF3n del hu\xE9sped, el due\xF1o reintegrar\xE1 el pago de la se\xF1a previa deducci\xF3n de los gastos administrativos del canal de pago. La cancelaci\xF3n debe realizarse siempre con m\xEDnimo de ", selectCancelacionGratis, " d\xEDas de antelaci\xF3n a la fecha de ingreso. Pasada esa fecha no se reintegrar\xE1 la se\xF1a ante una cancelaci\xF3n.");
    const cancelacionEstricta = (0, _react2.jsx)(_material.Box, null, (0, _react2.jsx)(_material.Typography, {
      css: _style.default.bold,
      component: "label"
    }, "Cancelaci\xF3n Estricta - Se\xF1a NO Reembolsable:"), " Ante la cancelaci\xF3n del hu\xE9sped, el due\xF1o del alojamiento NO reintegrar\xE1 el pago de la se\xF1a (pago anticipado).");
    const cancelacionFlexible = (0, _react2.jsx)(_material.Box, null, (0, _react2.jsx)(_material.Typography, {
      css: _style.default.bold,
      component: "label"
    }, "Cancelaci\xF3n Flexible - Se\xF1a Re-utilizable:"), " la cancelaci\xF3n del hu\xE9sped, el due\xF1o asignar\xE1 el monto de la se\xF1a abonada como cr\xE9dito en pesos para una futura reserva que se realice dentro de los pr\xF3ximos ", selectCancelacionFlexible, " meses (La nueva reserva estar\xE1 sujeta a disponibilidad).");
    const permitirEstadia = `Permitir estadía menor a ${estadiaMinima} noches entre reservas (huecos)`;
    return (0, _react2.jsx)("div", {
      css: _style.default.condicionesContainer
    }, (0, _react2.jsx)(_material.Box, {
      mt: 2
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, "Condiciones de reserva"), (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.formControl
    }, (0, _react2.jsx)(_material.InputLabel, {
      id: "demo-simple-select-label"
    }, "Porcentaje de se\xF1a"), (0, _react2.jsx)(_material.Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      autoWidth: true,
      label: "Porcentaje de se\xF1a",
      value: seña,
      name: "se\xF1a",
      onChange: e => this.handleChangeSelect(e)
    }, (0, _react2.jsx)(_material.MenuItem, {
      value: 20
    }, "20%"), (0, _react2.jsx)(_material.MenuItem, {
      value: 30
    }, "30%"), (0, _react2.jsx)(_material.MenuItem, {
      value: 40
    }, "40%"), (0, _react2.jsx)(_material.MenuItem, {
      value: 50
    }, "50%"))), (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.formControl
    }, (0, _react2.jsx)(_material.InputLabel, {
      id: "demo-simple-select-label"
    }, "Estadia m\xEDnima"), (0, _react2.jsx)(_material.Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      value: estadiaMinima,
      label: "estadia_minima",
      name: "estadia_minima",
      onChange: e => this.handleChangeSelect(e)
    }, optionsEstadiaMinima)), estadiaMinima > 1 ? (0, _react2.jsx)(_material.Grid, {
      container: true,
      direction: "column"
    }, (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.checkHuecos,
      control: (0, _react2.jsx)(_material.Checkbox, {
        checked: this.state.checkHuecos,
        onChange: this.handleChangeCheckHuecos,
        name: "checkHuecos",
        color: "primary"
      }),
      label: permitirEstadia
    }), (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.estadiaEntreReservas,
      disabled: !this.state.checkHuecos
    }, (0, _react2.jsx)(_material.InputLabel, {
      id: "demo-simple-select-label"
    }, "Estadia m\xEDnima entre reservas"), (0, _react2.jsx)(_material.Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      value: estadiaMinimaHuecos != null ? estadiaMinimaHuecos : [],
      label: "estad\xEDa m\xEDnima entre reservas",
      onChange: e => this.handleChangeSelect(e)
    }, optionsEstadiaMinimaEntreReservas))) : null, (0, _react2.jsx)(_material.Grid, {
      container: true,
      justifyContent: "space-between"
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 9,
      sm: 10
    }, (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.formControl
    }, (0, _react2.jsx)(_material.InputLabel, {
      id: "demo-simple-select-label"
    }, "Antelaci\xF3n minima para reservar"), (0, _react2.jsx)(_material.Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      value: antelacionMinima,
      name: "antelacion_minima",
      label: "Antelaci\xF3n m\xEDnima para reservar",
      onChange: e => this.handleChangeSelect(e)
    }, (0, _react2.jsx)(_material.MenuItem, {
      value: 0
    }, "0 d\xEDas"), (0, _react2.jsx)(_material.MenuItem, {
      value: 1
    }, "1 d\xEDa"), (0, _react2.jsx)(_material.MenuItem, {
      value: 2
    }, "2 d\xEDas"), (0, _react2.jsx)(_material.MenuItem, {
      value: 3
    }, "3 d\xEDas")))), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 2,
      sm: 1
    }, isMobile ? (0, _react2.jsx)(_material.Tooltip, {
      onClose: this.handleTooltipClose,
      onClick: this.handleTooltipOpen,
      open: this.state.openTooltip,
      disableHoverListener: true,
      disableTouchListener: true,
      title: "La cantidad de d\xEDas de anticipaci\xF3n m\xEDnima con la que te pueden hacer una reserva, Por ejemplo si pon\xE9s 1 significa que no te pueden reservar para el mismo d\xEDa, solo para el d\xEDa siguiente"
    }, (0, _react2.jsx)(_material.IconButton, {
      "aria-label": "delete"
    }, (0, _react2.jsx)(_HelpOutlined.default, null))) : (0, _react2.jsx)(_material.Tooltip, {
      title: "La cantidad de d\xEDas de anticipaci\xF3n m\xEDnima con la que te pueden hacer una reserva, Por ejemplo si pon\xE9s 1 significa que no te pueden reservar para el mismo d\xEDa, solo para el d\xEDa siguiente"
    }, (0, _react2.jsx)(_material.IconButton, {
      "aria-label": "delete"
    }, (0, _react2.jsx)(_HelpOutlined.default, null))))), (0, _react2.jsx)(_material.Grid, {
      container: true
    }, (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 6,
      sm: 6
    }, (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.horaIngresoYEgreso
    }, (0, _react2.jsx)(_material.InputLabel, {
      id: "demo-simple-select-label"
    }, "Hora Ingreso"), (0, _react2.jsx)(_material.Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      label: "hora_ingreso",
      value: horaIngreso != null ? horaIngreso : [],
      onChange: e => this.handleChangeSelect(e)
    }, (0, _react2.jsx)(_material.MenuItem, {
      value: 0
    }, "Consultar"), (0, _react2.jsx)(_material.MenuItem, {
      value: 8
    }, "08:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 9
    }, "09:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 10
    }, "10:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 11
    }, "11:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 12
    }, "12:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 13
    }, "13:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 14
    }, "14:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 15
    }, "15:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 16
    }, "16:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 17
    }, "17:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 18
    }, "18:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 19
    }, "19:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 20
    }, "20:00")))), (0, _react2.jsx)(_material.Grid, {
      item: true,
      xs: 6,
      sm: 6
    }, (0, _react2.jsx)(_material.FormControl, {
      css: _style.default.horaIngresoYEgreso
    }, (0, _react2.jsx)(_material.InputLabel, {
      id: "demo-simple-select-label"
    }, "Hora Egreso"), (0, _react2.jsx)(_material.Select, {
      labelId: "demo-simple-select-label",
      id: "demo-simple-select",
      label: "hora_egreso",
      name: "hora_egreso",
      value: horaEgreso != null ? horaEgreso : [],
      onChange: e => this.handleChangeSelect(e)
    }, (0, _react2.jsx)(_material.MenuItem, {
      value: 0
    }, "Consultar"), (0, _react2.jsx)(_material.MenuItem, {
      value: 8
    }, "08:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 9
    }, "09:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 10
    }, "10:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 11
    }, "11:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 12
    }, "12:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 13
    }, "13:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 14
    }, "14:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 15
    }, "15:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 16
    }, "16:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 17
    }, "17:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 18
    }, "18:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 19
    }, "19:00"), (0, _react2.jsx)(_material.MenuItem, {
      value: 20
    }, "20:00")))))), (0, _react2.jsx)(_material.Box, {
      mt: 4
    }, (0, _react2.jsx)(_material.Typography, {
      variant: "h6"
    }, "Politicas de cancelaci\xF3n"), (0, _react2.jsx)(_material.FormControl, {
      component: "fieldset"
    }, (0, _react2.jsx)(_material.RadioGroup, {
      "aria-label": "gender",
      name: "gender1",
      value: cancelacion,
      onChange: this.handleChangeCancelacion
    }, (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.politicas,
      name: "cancelacion",
      value: "estricta",
      control: (0, _react2.jsx)(_material.Radio, {
        color: "primary"
      }),
      label: cancelacion == "estricta" ? cancelacionEstricta : (0, _react2.jsx)(_material.Typography, {
        css: _style.default.bold,
        component: "label"
      }, "Cancelaci\xF3n Estricta - Se\xF1a NO Reembolsable")
    }), (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.politicas,
      name: "cancelacion",
      value: "flexible",
      control: (0, _react2.jsx)(_material.Radio, {
        color: "primary"
      }),
      label: cancelacion == "flexible" ? cancelacionFlexible : (0, _react2.jsx)(_material.Typography, {
        css: _style.default.bold,
        component: "label"
      }, "Cancelaci\xF3n Flexible - Se\xF1a Re-utilizable")
    }), (0, _react2.jsx)(_material.FormControlLabel, {
      css: _style.default.politicas,
      name: "cancelacion",
      value: "gratis",
      control: (0, _react2.jsx)(_material.Radio, {
        color: "primary"
      }),
      label: cancelacion == "gratis" ? cancelacionGratis : (0, _react2.jsx)(_material.Typography, {
        css: _style.default.bold,
        component: "label"
      }, "Cancelaci\xF3n Gratis - Se\xF1a Reembolsable")
    })))));
  }

}

exports.CondicionesDeReserva = CondicionesDeReserva;
var _default = CondicionesDeReserva;
exports.default = _default;